module.exports = __webpack_public_path__ + "c96212.pdf";